import { siteApiSlice } from "../../app/siteApiSlice";
import { SelectListItem } from "../../components/input/SelectList";
import { RulesModel } from "../account/accountApiSlice";

export interface ProctorRegistrationUserEditModel {
	rules: RulesModel;
	fName: string;
	lName: string;
	emailAddress: string;
	phone?: string;
	externalID: string;
	hash: string;
	birthmonth: string;
	birthday: string;
	gender: number;
	username: string;
	password: string;
	confirmPassword: string;
	possibleMonths: SelectListItem[];
	possibleDays: SelectListItem[];
	possibleGenders: SelectListItem[];
}

export const registrationApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		getRegisterProctorInfo: build.query<ProctorRegistrationUserEditModel, void>({
			query: () => ({ url: `/Registration/RegisterProctor`, method: "GET" }),
		}),
		registerProctor: build.mutation<void, ProctorRegistrationUserEditModel>({
			query: (payload) => ({
				url: `/Registration/RegisterProctor`,
				method: "POST",
				body: payload,
			}),
		}),
	}),
});

export const { useGetRegisterProctorInfoQuery, useRegisterProctorMutation } = registrationApiSlice;
